import axios from 'axios';
import _ from 'lodash';
import { batchQuery, getMonthlyReportsQuery, getProducersQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { resolveId } from '../../utils';

const getMonthlyReportDetails = (id) =>
    new Promise((resolve, reject) => {
        const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
        const migrationQueryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
        const useExpressAuth = Split.getBooleanTreatment('use_express_auth_endpoints');
        const authQueryBuilder = useExpressAuth ? buildExpressQuery : buildLoopbackQuery;
        const monthlyReportQuery = id ? getMonthlyReportsQuery({ producerId: id, filterDeleted: true, queryBuilder: migrationQueryBuilder }) : getMonthlyReportsQuery({ filterDeleted: true, queryBuilder: migrationQueryBuilder });
        const monthlyReportRequest = axios.get(monthlyReportQuery);

        monthlyReportRequest
            .then((monthlyReportResponse) => {
                const monthlyReports = monthlyReportResponse.data;
                const producerIds = _.filter(_.uniq(_.map(monthlyReports, 'producer_id')), (pid) => pid != null);

                if (!producerIds.length) {
                    const response = _.map(monthlyReports, (report) => ({
                        attachment: report.attachment,
                        created_at: report.created_at,
                        id: report.id,
                        producer: [{ id: report.producer_id, name: report.producer_id ? '' : 'All Producers' }],
                        type: report.type,
                        read_status: report.read_status,
                        updated_at: report.updated_at,
                        is_adjusted: report.is_adjusted,
                        report_date: report.report_date,
                    }));
                    resolve({ monthlyReports: response });
                    return;
                }

                const producerQuery = batchQuery(getProducersQuery, { fields: ['id', 'name'], ids: producerIds, queryBuilder: authQueryBuilder }, 'ids');
                const producerRequest = _.map(producerQuery, (q) => axios.get(q));

                axios.all(producerRequest).then(
                    axios.spread((...producerResponse) => {
                        const producers = _.reduce(producerResponse, (acc, val) => [...acc, ...(Array.isArray(val.data) ? val.data.filter(Boolean).map(resolveId) : [])], []);
                        const response = _.map(monthlyReports, (report) => ({
                            attachment: report.attachment,
                            created_at: report.created_at,
                            id: report.id,
                            producer: [{ id: report.producer_id, name: report.producer_id ? (_.find(producers, { id: report.producer_id }) ? _.find(producers, { id: report.producer_id }).name : '') : 'All Producers' }],
                            type: report.type,
                            read_status: report.read_status,
                            updated_at: report.updated_at,
                            is_adjusted: report.is_adjusted,
                            report_date: report.report_date,
                        }));
                        resolve({ monthlyReports: response });
                    })
                );
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getMonthlyReportDetails;
